import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";

// Initial state
const initialState = {
  token: null,
  isLoading: false,
  isLoggedIn: false, // added
  after_login_data: null, // use null instead of []
  email: null,
  login_error: null,
};

// Actions
export const LOGIN_ACTION = "admin/login";

// LOGIN
export const LoginUser = createAsyncThunk(
  LOGIN_ACTION,
  async (loginData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(LOGIN_ACTION, loginData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Invalid Credentials");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Invalid Credentials"
      );
    }
  }
);

// Slice
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout(state) {
      state.token = null;
      state.isLoading = false;
      state.isLoggedIn = false;
      state.after_login_data = null;
      state.login_error = null;
      state.email = null;
      localStorage.removeItem("token"); // optional
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(LoginUser.pending, (state) => {
        state.isLoading = true;
        state.login_error = null;
      })
      .addCase(LoginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.after_login_data = action.payload;
        state.token = action.payload.token;
        state.isLoggedIn = true;
      })
      .addCase(LoginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.login_error = action.payload;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
